import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class LogoutService {

	readonly _isAuthcate = new BehaviorSubject<boolean>(false);
	readonly isAuthcate$ = this._isAuthcate.asObservable();

	constructor() { }
}
